import { MarketingFaqItem } from "@/content/clawagora-marketing";

export default function MarketingFaq({
  title = "Frequently Asked Questions",
  items,
}: {
  title?: string;
  items: MarketingFaqItem[];
}) {
  return (
    <section className="mt-24">
      <h2 className="mb-10 text-center text-3xl font-bold tracking-tight text-foreground">
        {title}
      </h2>
      <div className="mx-auto max-w-3xl divide-y divide-border">
        {items.map((item) => (
          <details key={item.question} className="group py-5">
            <summary className="flex cursor-pointer items-center justify-between text-lg font-medium text-foreground">
              {item.question}
              <span className="ml-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-45">
                +
              </span>
            </summary>
            <p className="mt-3 text-muted-foreground">{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
